import React from 'react';
import { Modal, Typography, List, Tag, Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import PromptDiffView from './PromptDiffView';

const { Text, Paragraph } = Typography;

const SLOT_LABELS = {
  system_prompt: 'Instructions',
  custom_prompt: 'Bot prompt',
  style_prompt: 'Style instructions',
  relevance_scope: 'Domain scope',
};

const TARGET_LABELS = {
  assistant: 'Assistant',
  bot: 'Bot',
  widget: 'Widget',
  api_key: 'API key',
};

export default function PromptImpactModal({
  open,
  onCancel,
  onConfirm,
  bindings = [],
  diffParts = [],
  oldText = '',
  newText = '',
  confirmLoading = false,
  confirmLabel,
}) {
  const count = bindings.length;
  const label = confirmLabel || (count > 1 ? `Publish to ${count} surfaces` : 'Publish');

  return (
    <Modal
      title={
        <Space>
          <WarningOutlined style={{ color: 'var(--color-warning)' }} />
          <span>Review changes before publishing</span>
        </Space>
      }
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={label}
      confirmLoading={confirmLoading}
      width={640}
    >
      <Paragraph type="secondary">
        {count > 0
          ? 'This prompt is linked to the following surfaces. Publishing will update all of them.'
          : 'Review your changes before publishing.'}
      </Paragraph>

      <div className="prompt-impact-diff" style={{ marginBottom: 16, maxHeight: 240, overflow: 'auto' }}>
        <PromptDiffView oldText={oldText} newText={newText} parts={diffParts.length ? diffParts : null} />
      </div>

      {count > 0 && (
        <List
          size="small"
          dataSource={bindings}
          renderItem={(b) => (
            <List.Item>
              <Space>
                <Tag>{TARGET_LABELS[b.target_type] || b.target_type}</Tag>
                <Text strong>{b.target_name || `#${b.target_id}`}</Text>
                <Text type="secondary">{SLOT_LABELS[b.slot] || b.slot}</Text>
              </Space>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
}
